import module from 'guest/module.js'
import template from './template.html'

class GuestInformacionSatComponent {
  constructor ($dialog, $translate) {
    this.$dialog = $dialog
    this.$translate = $translate
    this.idEmpresa = null
    this.idEmpleado = null
    this.data = null
    this.catalogos = null
    this.declaraciones = undefined
    this.deducciones = undefined
    this.retenciones = undefined
  }

  enviarDeducciones () {
    this.$dialog.show('guestInformacionSatEnviardeducciones', {ID_Empresa: this.idEmpresa, ID_Empleado: this.idEmpleado})
      .then(() => (this.obtenerDeducciones()))
  }

  urlDocumento () {
    let lang = this.$translate.use()
    return 'data/public/DeclaracionAnualClientesAsimilados2015-' + lang + '.pdf'
  }
}

module.component('guestInformacionSat', {
  controller: GuestInformacionSatComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idEmpleado: '<',
    data: '<',
    catalogos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/informacion/sat/component.js